import type { Tab, VITRINS_OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import { ProxyClient } from './clients/ProxyClient';

export interface GetOffersByLocationAndPutToCacheParams {
  location: string;
  offerTypes: Tab<VITRINS_OFFERS_TYPE>[];
  bonusFilter?: string[];
  organizationId?: string[];
}

export type OffersByType = {
  [key in VITRINS_OFFERS_TYPE]: any[];
};

export const getOffersByLocationAndPutToCache = async (
  params: GetOffersByLocationAndPutToCacheParams,
): Promise<OffersByType> => {
  const typesForRequest = params.offerTypes.map((tab) => (tab.subtype ? [tab.type, tab.subtype] : [tab.type]));

  const { data } = await ProxyClient.post('/offers/get-by-location', {
    ...params,
    offerTypes: typesForRequest,
  });

  return data;
};
